import styled from "styled-components";
import { md, sm } from "../../constants/layout";

export const NewsWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
  margin-bottom: 30px;

  @media screen and (max-width: ${md}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: ${sm}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const NewsItem = styled.div`
  background: #fff;
  a {
    text-decoration: none;
  }

  :hover {
    cursor: pointer;
    background: #fc7722;
  }
  :hover * {
    color: #fff;
  }
`;

export const NewsContainer = styled.div`
  padding: 15px 20px;
`;

export const NewsInfo = styled.div`
  display: flex;
`;

export const NewsInfoItem = styled.div`
  display: flex;
  margin: 5px 0;
  align-items: center;
`;

export const NewsInfoIcon = styled.span`
  color: #b7b7b7;
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

export const NewsSubTitle = styled.div`
  margin-top: 10px;
  height: 69px;
  line-height: 1.2rem;
  overflow: hidden;
`;
